<template>
  <b-badge
    v-if="statusName"
    :variant="statusVariant"
    class="text-capitalize"
  >
    {{ displayText }}
  </b-badge>
  <span v-else class="text-muted">-</span>
</template>

<script>
import { getStatusVariant } from '../useWorkflow'

export default {
  name: 'StatusBadge',
  props: {
    status: {
      type: [String, Object],
      default: null,
    },
  },
  computed: {
    statusName() {
      if (!this.status) return null
      return typeof this.status === 'object' ? (this.status && this.status.name) || '' : this.status
    },
    statusVariant() {
      return getStatusVariant(this.statusName)
    },
    displayText() {
      if (!this.statusName) return ''
      const normalized = String(this.statusName).toLowerCase().replace(/\s/g, '_')
      const key = `policy_exception.status_${normalized}`
      const translated = this.$t(key)
      return translated !== key ? translated : this.statusName
    },
  },
}
</script>
